async function GenerateImage(ingrediant) {
  let query = "An image of " + ingrediant;
  console.log("Query: " + query);

  const key =
    "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";
  const myHeaders = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + key,
  };

  var raw = JSON.stringify({
    model: "dall-e-2",
    prompt: query,
    n: 1,
    response_format: "url",
    size: "256x256",
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      "https://api.openai.com/v1/images/generations",
      requestOptions
    );
    const result = await response.json();
    return result.data[0].url;
  } catch (error) {
    console.error("Image generation error:", error);
    return "fallback.jpg"; // fallback image
  }
}

async function ModernFetchImage(ingredient) {
  const url = "https://api.unsplash.com/search/photos/";
  const clientId = "client_id=BMSTU5W_PEWe0vzTxizV4c_eLEEKgSEyx_g4cm9sOCw&";
  const query = `query=${encodeURIComponent(
    ingredient
  )}&count=1&orientation=portrait`;
  const fullUrl = `${url}?${clientId}&${query}`;

  try {
    const response = await fetch(fullUrl);
    const data = await response.json();
    return data.results[0]?.urls?.thumb || "fallback.jpg"; // handle missing images
  } catch (error) {
    console.error("Image fetch error:", error);
    return "fallback.jpg";
  }
}
